//people reducer types
export const LOADING_CUSTOMFIELD = "LOADING_CUSTOMFIELD";
export const LOAD_CUSTOMFIELD = "LOAD_CUSTOMFIELD";
export const CUSTOMFIELD_SAVE_REQUEST = "CUSTOMFIELD_SAVE_REQUEST";
export const CUSTOMFIELD_SAVE_SUCCESS = "CUSTOMFIELD_SAVE_SUCCESS";
export const FETCH_CUSTOMFIELD_REQUEST = "FETCH_CUSTOMFIELD_REQUEST";
export const FETCH_CUSTOMFIELD_REQUEST_SUCCESS =
  "FETCH_CUSTOMFIELD_REQUEST_SUCCESS";
